import React from "react";
import { ReadonlyFieldProps } from "../types";
import { COLORS, FIELD_COLORS } from "../constants";

const EditSalaryInput: React.FC<ReadonlyFieldProps> = ({
  label,
  value,
  labelColor = FIELD_COLORS.defaultLabelColor,
  valueColor = FIELD_COLORS.defaultValueColor,
  valueBgColor = FIELD_COLORS.defaultValueBgColor,
  icon,
  onChange,
  isInvalid = false,
}) => (
  <div className="col-md-3 mb-4">
    <label className="form-label" style={{ color: labelColor }}>
      {label}
      {icon && (
        <i
          className={icon}
          style={{ marginLeft: 8, color: COLORS.TEXT_ICON }}
        />
      )}
    </label>

    {/* BASELINE FIELD STRUCTURE */}
    <div
      style={{
        background: valueBgColor,
        borderRadius: "14px",
        padding: "10px 10px",
        border: isInvalid ? "1px solid #d92d20" : "none",
      }}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="form-control"
        style={{
          background: "transparent",
          border: "none",
          boxShadow: "none",
          color: valueColor,
        }}
      />
    </div>
  </div>
);

export default EditSalaryInput;
